(function() {
  'use strict';

  angular
    .module('quiz.labelingItemsInPicture', [])
    .controller('LabelingItemsInPictureCtrl', LabelingItemsInPictureCtrl);

  LabelingItemsInPictureCtrl.$inject = ['$scope', '$timeout', '$window'];

  function LabelingItemsInPictureCtrl($scope, $timeout, $window) {
    var question = $scope.question;
    var imageData = question.image;

    var screenWidth = $window.innerWidth;
    var mode = screenWidth <= 768 ? 'mobile' : 'desktop';
    $scope.lipViewMode = mode;

    function setupCaptions() {
      return _.map(question.captions, function (caption, index) {
        return {
          id: caption.id,
          text: caption.text,
          isCorrect: false,
          index: index
        };
      });
    }

    function calcMobileDimensions() {
      $scope.selectorData = {
        singleSelect: _.map(question.regions, function() { return null })
      };

      $scope.mobileStyle = {};
      $scope.mobileStyle.containerWidth = screenWidth - 105;
      // This aspect ratio is tied to the arranger
      $scope.mobileStyle.containerHeight =  Math.round(530 / 773 * $scope.mobileStyle.containerWidth);
      $scope.mobileStyle.selectorHeight = 45;

      $scope.mobileStyle.lipContainer = {
        height: $scope.mobileStyle.containerHeight + $scope.mobileStyle.selectorHeight * $scope.selectorData.singleSelect.length + 'px'
      };

      if (mode === 'mobile') {
        $scope.mobileStyle.lipSelectorBox = {
          top: $scope.mobileStyle.containerHeight + 'px',
          width: '305px'
        };
      } else {
        $scope.mobileStyle.lipSelectorBox = {
          top: $scope.mobileStyle.containerHeight + 'px',
          width: $scope.mobileStyle.containerWidth + 'px'
        };
      }

      $scope.mobileStyle.lipImageBox = {
        height: $scope.mobileStyle.containerHeight + 'px',
        width: $scope.mobileStyle.containerWidth + 'px'
      };
    }

    var traineeBoxWidth = 773;
    var traineeBoxHeight = 530;
    var insideBoxOffsetX = 2;
    var viewModel;

    if (mode == 'mobile') {
      calcMobileDimensions();
      traineeBoxWidth = $scope.mobileStyle.containerWidth;
      traineeBoxHeight = $scope.mobileStyle.containerHeight;
    }

    $scope.traineeBoxWidth = traineeBoxWidth;
    $scope.traineeBoxHeight = traineeBoxHeight;

    $scope.$watch('state.tryAgainRequested', function(newValue) {
      if (!newValue) return;
      $scope.question.correctAnswer = null;
    });

    $scope.$watch('question.correctAnswer', function(newValue, oldValue) {
      if (newValue == oldValue) return;
      setupViewModel();
    });

    $scope.$watch('state.answerGraded', updateDragState);
    $scope.$watch('state.answerSubmitted', updateDragState);

    function updateDragState() {
      $scope.dragDisabled = $scope.state.answerGraded || $scope.state.answerSubmitted;
    }

    setupViewModel();
    updateAnswerSelected();

    if (mode == 'mobile') {
      $scope.selectorData = {
        singleSelect: _.map($scope.viewModel.regions, function (region) {
          if (region.caption) {
            return (region.caption.id || region.caption.id === 0) ? region.caption.id.toString() : null;
          } else {
            return null;
          }
        })
      };
    }

    function setupViewModel() {
      $scope.xScale = traineeBoxWidth / question.boxWidth;
      $scope.yScale = traineeBoxHeight / question.boxHeight;

      $scope.viewModel = viewModel = {
        showPartialCorrect: question.partialCorrect,
        labelBoxActive: false,
        dragProxyActive: false,
        showDragOverlay: false
      };

      viewModel.regions = _.map(question.regions, function(region) {
        return {
          id: region.id,
          x: Math.round($scope.xScale * region.x),
          y: Math.round($scope.yScale * region.y),
          width: Math.round($scope.xScale * region.width) - insideBoxOffsetX * 2,
          height: Math.round($scope.yScale * region.height) - insideBoxOffsetX * 2,
          caption: null
        }
      });

      viewModel.captions = setupCaptions();

      if (question.correctAnswer) {
        _.each(question.correctAnswer, function(answer) {
          var region = _.find(viewModel.regions, function(region) {
            return region.id == answer.regionId;
          });
          var caption = _.find(viewModel.captions, function(caption) {
            return caption.text == answer.userAnswerText;
          });

          caption.isCorrect = answer.isCorrect;
          caption.correctAnswerText = answer.isCorrect ? answer.userAnswerText : answer.correctAnswerText;
          caption.userAnswerText = answer.userAnswerText;
          caption.regionIdx = region.id;

          region.caption = caption;
        });
      }
      else if ($scope.answer.selectedAnswer) {
        _.each(viewModel.regions, function(region) {
          var answerText = $scope.answer.selectedAnswer[region.id];
          if (answerText && answerText.length > 0) {
            var caption = _.find(viewModel.captions, function(caption) {
              return caption.text == answerText;
            });
            if (caption) {
              region.caption = caption;
              caption.regionIdx = region.id;
            }
          }
        });
      }

      viewModel.image = {
        boundingBoxWidth: question.boxWidth,
        boundingBoxHeight: question.boxHeight,
        originX: imageData.x,
        originY: imageData.y,
        editedImageScale: imageData.scale,
        src: imageData.url
      }
    }

    function updateAnswerSelected() {
      $scope.state.answerSelected = _.all(viewModel.regions, function(region) {
        return region.caption;
      });
    }

    function refreshState() {
      updateAnswerSelected();

      if (viewModel) {
        $scope.answer.selectedAnswer = _.map(
          _.sortBy(viewModel.regions, function(region) {
            return region.id
          }),
          function(region) {
            return region.caption ? region.caption.text : '';
          });
      }
      else {
        $scope.answer.selectedAnswer = null;
      }
      $scope.storeSelectedAnswer();
    }

    $scope.onSelectionChanged = function(region, selectionIndex) {
      var captionIndex = $scope.selectorData.singleSelect[selectionIndex];
      var caption = captionIndex === '' ? null : $scope.viewModel.captions[captionIndex];
      $scope.onCaptionDroppedOnRegion(region, caption, true);
    }

    $scope.onCaptionDroppedOnRegion = function(region, caption, mobileMode) {
      if (caption && region.id === caption.regionIdx && !mobileMode)
        return $scope.$broadcast('redraw');

      if (caption && caption.regionIdx != null) {
        if (mobileMode) {
          $scope.selectorData.singleSelect[caption.regionIdx] = null;
        }
        viewModel.regions[caption.regionIdx].caption = null;
      }

      if (region.caption)
        region.caption.regionIdx = null;

      region.caption = caption;
      if (caption) {
        caption.regionIdx = region.id;
      }
      refreshState();
    };

    $scope.getRegionSizeStyle = function(region) {
      return {
        top: region.y,
        left: region.x,
        width: region.width,
        height: region.height
      };
    };

    $scope.$watch('state.showAnswersRequested', function(showAnswers) {
      if (!$scope.state.answerGraded)
        return;

      _.each(viewModel.captions, function(caption) {
        caption.text = showAnswers ? caption.correctAnswerText : caption.userAnswerText;
      });
    });

    $scope.getRegionLabelClass = function(regionIdx) {
      var region = viewModel.regions[regionIdx];
      if (!region) return;
      var regClass = "";

      if (region.caption && $scope.state.answerGraded) {
        if ($scope.state.showAnswersRequested) {
          regClass = viewModel.showPartialCorrect ? "review-partial-correct" : "review-no-partial-correct";
        }
        else if (viewModel.showPartialCorrect) {
          regClass = region.caption.isCorrect ? "correct" : "incorrect";
        }
        else {
          regClass = "disabled";
        }
      }

      if (region.captionPosition && region.captionPosition.left) {
        regClass += " rightArrow";
      }

      if (region.selected) {
        regClass += " selected";
      }

      return regClass;
    };
  }
})();